import { Link, Typography } from "@mui/material"
import { Mobile } from "common/MediaQueries"
import styled from "styled-components"
import { StyledSvgIcon } from "theme/shared"
import { Font, FontSize } from "./showRooms/ShowRoomItem"

const StyledText = styled(Typography).attrs({ variant: "body1" })<{
  $font?: Font
  $fontSize?: FontSize
}>`
  font-weight: 300;
  ${(p) => p?.$font && `font-family: ${p?.$font};`}
  ${(p) => p?.$fontSize && `font-size: ${p?.$fontSize}px;`}
`

const StyledContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const StyledLink = styled(Link)`
  color: ${(p) => p.theme.colors.saphire} !important;
  text-decoration: underline;
  cursor: pointer;
  p {
    color: ${(p) => p.theme.colors.saphire} !important;
  }
`

type CardRowTextProps = {
  data: string
  iconName?: string
  link?: string
  iconInMobile?: boolean
  font?: Font
  fontSize?: FontSize
  imageAlt?: string
  trackEvent?: () => void
}

const CardRowText = ({
  data,
  iconName,
  link = "",
  iconInMobile = false,
  font,
  fontSize,
  imageAlt,
  trackEvent,
}: CardRowTextProps) => (
  <>
    {data && (
      <StyledContent onClick={() => trackEvent && trackEvent()}>
        {iconName && (
          <>
            {iconInMobile ? (
              <Mobile>
                <StyledSvgIcon src={`/icons/${iconName}.svg`} alt={imageAlt} />
              </Mobile>
            ) : (
              <StyledSvgIcon src={`/icons/${iconName}.svg`} alt={imageAlt} />
            )}
          </>
        )}
        {link !== "" ? (
          <StyledLink href={link} rel="noopener noreferrer" target="_blank">
            <StyledText $font={font} $fontSize={fontSize}>
              {data}
            </StyledText>
          </StyledLink>
        ) : (
          <StyledText $font={font} $fontSize={fontSize}>
            {data}
          </StyledText>
        )}
      </StyledContent>
    )}
  </>
)

export default CardRowText
